import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { useCallback } from 'react';
import { PowerPlayerBolt } from '../../../assets/powerPlayerBolt';
import { useSocketSend } from '../../../context/webSocket/webSocketContext';
import { PanelItem } from '../../../panels/panelItem';
import { thunkShowPlayerInfo } from '../../../redux/actions/playerInfoActions';
import { useAppDispatch, useAppSelector } from '../../../redux/store';
import { LIGHT_GREEN_COLOR, MTT_STAGING_MAIN_PANEL_HOVER_COLOR } from '../../../styles/colors';
import { getShortRenderedValueStr } from '../../../utils/numberPrecisionUtils';
const READY_COLOR_CSS = css `
  color: ${LIGHT_GREEN_COLOR};
`;
const STATUS_CSS = css `
  display: flex;
  flex-direction: row;
  gap: 2px;
  align-items: center;
`;
const POWER_PLAYER_BOLT_ACTIVE_CSS = READY_COLOR_CSS;
const POWER_PLAYER_BOLT_INACTIVE_CSS = css `
  color: white;
  opacity: 0.25;
`;
export const MttStagingPlayerDisplay = ({ player }) => {
    const dispatch = useAppDispatch();
    const socketSend = useSocketSend();
    const bonusMttStartingChipsPercentForPowerPlayer = useAppSelector((state) => state.mttStaging.bonusMttStartingChipsPercentForPowerPlayer);
    // TODO: Add a test for clicking a player in the main panel:
    const onClick = useCallback(() => {
        dispatch(thunkShowPlayerInfo(player, socketSend));
    }, [dispatch, player, socketSend]);
    return (_jsxs(PanelItem, { ariaLabel: player.name, onClick: onClick, hoverColor: MTT_STAGING_MAIN_PANEL_HOVER_COLOR, allowUserSelect: false, children: [_jsx("span", { "aria-hidden": true, css: player.isMttReady && READY_COLOR_CSS, children: player.name }), _jsxs("div", { css: STATUS_CSS, style: { visibility: player.isMttReady ? 'visible' : 'hidden' }, "aria-label": `${player.name} is ${player.isMttReady ? '' : 'not '}ready`, children: [player.mttStartingChips ? (_jsx("span", { "aria-label": 'starting chips', css: READY_COLOR_CSS, children: getShortRenderedValueStr(player.mttStartingChips) })) : null, bonusMttStartingChipsPercentForPowerPlayer ? (_jsx("div", { css: player.isPowerPlayer ? POWER_PLAYER_BOLT_ACTIVE_CSS : POWER_PLAYER_BOLT_INACTIVE_CSS, children: _jsx(PowerPlayerBolt, { color: 'currentColor' }) })) : null] })] }));
};
